import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const COUNT = ["3", "2", "1"];

export const Preloader = ({ onComplete }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timers = COUNT.map((_, i) => setTimeout(() => setStep(i + 1), 700 * (i + 1)));
    timers.push(setTimeout(onComplete, 700 * COUNT.length + 350));
    return () => timers.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <motion.div
      data-testid="intro-preloader"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center overflow-hidden"
    >
      <div className="sprocket-strip absolute top-8 inset-x-8 opacity-40" />
      <div className="sprocket-strip absolute bottom-8 inset-x-8 opacity-40" />

      <div className="relative w-52 h-52 sm:w-64 sm:h-64 flex items-center justify-center">
        <motion.span
          aria-hidden
          className="absolute inset-0 rounded-full border border-ivory/15"
          animate={{ rotate: 360 }}
          transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
          style={{ borderTopColor: "#E5C07B" }}
        />
        <span aria-hidden className="absolute inset-5 rounded-full border border-ivory/10" />
        {step < COUNT.length ? (
          <motion.span
            key={step}
            initial={{ opacity: 0, scale: 1.25 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-8xl sm:text-9xl text-ivory"
          >
            {COUNT[step]}
          </motion.span>
        ) : (
          <motion.span
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="font-display text-sm tracking-[0.5em] text-amber uppercase"
          >
            Roll
          </motion.span>
        )}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="font-display text-xs tracking-[0.55em] text-ivory/70 uppercase mt-10"
      >
        Ansh Agarwal Films
      </motion.p>
      <motion.p
        animate={{ opacity: [0.3, 1, 0.3] }}
        transition={{ duration: 1.4, repeat: Infinity }}
        className="font-mono text-[9px] tracking-[0.4em] text-mute uppercase mt-3"
      >
        Loading Reel
      </motion.p>
    </motion.div>
  );
};
